import React from "react";

// 1200 x 630 — Open Graph / Twitter Card preview image for link sharing.
// Captured to /public/og-image.png by a Playwright pass.

export default function OgCard() {
  return (
    <div
      style={{
        width: "1200px",
        height: "630px",
        background: "#000",
        position: "relative",
        overflow: "hidden",
        fontFamily: "Manrope, sans-serif",
        color: "#ece9e2",
      }}
      data-testid="og-card"
    >
      {/* Gold radial spotlights */}
      <div
        style={{
          position: "absolute",
          top: "-150px",
          right: "-150px",
          width: "700px",
          height: "700px",
          borderRadius: "9999px",
          filter: "blur(80px)",
          opacity: 0.18,
          background: "radial-gradient(circle, #c6a263 0%, transparent 60%)",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "-200px",
          left: "-100px",
          width: "600px",
          height: "600px",
          borderRadius: "9999px",
          filter: "blur(80px)",
          opacity: 0.12,
          background: "radial-gradient(circle, #c6a263 0%, transparent 60%)",
        }}
      />

      {/* Hairline frame */}
      <div
        style={{
          position: "absolute",
          inset: "40px",
          border: "1px solid rgba(198,162,99,0.4)",
          borderRadius: "20px",
        }}
      />

      <div
        style={{
          position: "absolute",
          inset: 0,
          padding: "90px 110px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {/* Top — brand badge */}
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          {/* UC mark */}
          <svg width="80" height="80" viewBox="0 0 100 100">
            <defs>
              <linearGradient id="ogGold" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#f3dca0" />
                <stop offset="55%" stopColor="#c6a263" />
                <stop offset="100%" stopColor="#8d6c2c" />
              </linearGradient>
            </defs>
            <text
              x="0"
              y="76"
              fontSize="92"
              fontFamily="Cinzel, Georgia, serif"
              fontWeight={500}
              fill="url(#ogGold)"
              letterSpacing="-5"
            >
              U
            </text>
            <text
              x="32"
              y="86"
              fontSize="92"
              fontFamily="Cinzel, Georgia, serif"
              fontWeight={500}
              fill="url(#ogGold)"
              letterSpacing="-5"
            >
              C
            </text>
          </svg>
          <div
            style={{
              fontFamily: "Cinzel, Georgia, serif",
              fontWeight: 500,
              fontSize: 14,
              letterSpacing: "0.4em",
              textTransform: "uppercase",
              color: "#ddc58e",
            }}
          >
            Uberti Creative · Vaughan / GTA
          </div>
        </div>

        {/* Headline */}
        <div>
          <div
            style={{
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontWeight: 500,
              fontSize: 78,
              lineHeight: 1.02,
              color: "#ece9e2",
              letterSpacing: "-0.015em",
            }}
          >
            Elevating brands through
            <br />
            content, strategy, and{" "}
            <span style={{ fontStyle: "italic", color: "#ddc58e" }}>
              design
            </span>
            .
          </div>
          <div
            style={{
              marginTop: 26,
              maxWidth: 820,
              fontSize: 22,
              lineHeight: 1.4,
              color: "#a8a290",
            }}
          >
            Social media content, short-form video, brand direction, and
            digital storytelling — built for businesses that want to look
            sharper online.
          </div>
        </div>

        {/* Bottom — CTA pill */}
        <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
          <div
            style={{
              padding: "16px 30px",
              borderRadius: "9999px",
              background:
                "linear-gradient(180deg, #d8be84 0%, #c6a263 55%, #a3823f 100%)",
              color: "#0a0700",
              fontSize: 18,
              fontWeight: 600,
              letterSpacing: "0.04em",
            }}
          >
            Start a Project →
          </div>
          <div
            style={{
              fontFamily: "Cinzel, Georgia, serif",
              fontSize: 13,
              letterSpacing: "0.36em",
              textTransform: "uppercase",
              color: "#a8a290",
            }}
          >
            uberticreative.com
          </div>
        </div>
      </div>
    </div>
  );
}
